import {
  Button, Form, Input, Pagination, Space, Table,
} from 'antd';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import useTranslation from '../../../hooks/translation/useTranslation';

function Stations() {
  const { trans } = useTranslation();
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState();

  useEffect(() => {
    axios.get('/api/stations', { params: { page, search } }).then((res) => {
      if (res.data?.status === 'success') {
        setData(res?.data?.data);
      }
    });
  }, [page, search]);

  const columns = [
    {
      title: trans('system_code'),
      dataIndex: 'station_code',
      key: 'station_code',
    },
    {
      title: trans('system_id'),
      dataIndex: 'station_id',
      key: 'station_id',
    },
    {
      title: trans('name_ka'),
      dataIndex: 'name_ka',
      key: 'name_ka',
    },
    {
      title: trans('name_en'),
      dataIndex: 'name_en',
      key: 'name_en',
    },
    {
      title: trans('name_ru'),
      dataIndex: 'name_ru',
      key: 'name_ru',
    },
    {
      title: trans('hidden'),
      dataIndex: 'hide',
      key: 'hide',
      render: (hide) => <div>{hide ? 'კი' : 'არა' }</div>,
    },
    {
      title: trans('country'),
      dataIndex: 'station_country',
      key: 'station_country',
    },
    {
      title: trans('edit'),
      dataIndex: 'edit',
      key: 'edit',
    },
  ];

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <div className="overflow-table">
        <Form layout="vertical" style={{ maxWidth: '300px' }}>
          <Form.Item
            label={trans('search')}
            name="search"
          >
            <Input onChange={(e) => setSearch(e.target.value)} />
          </Form.Item>
        </Form>
        <Space size="large" direction="vertical" style={{ width: '100%' }}>
          <Table
            pagination={false}
            dataSource={data?.data?.map((station) => ({
              key: station.id,
              station_id: station?.station_id,
              station_code: station?.station_code,
              name_ka: station?.name_ka,
              name_en: station?.name_en,
              name_ru: station?.name_ru,
              station: station?.name,
              station_country: station?.station_country,
              hide: station?.hide,
              edit: (
                <Link to={`/admin/stations/${station.id}/edit`}>
                  <Button>
                    {trans('edit')}
                  </Button>
                </Link>
              ),
            }))}
            columns={columns}
          />
          {data && (
          <Pagination
            total={data?.meta?.totalItems}
            pageSize={data?.meta?.itemsPerPage}
            showSizeChanger={false}
            current={page}
            onChange={(e) => setPage(e)}
          />
          )}
        </Space>
      </div>
    </Space>
  );
}

export default Stations;
